/* eslint-disable max-lines */
import {
  ORIENTAL_ORANGE,
  COLOR2,
  ORIENTAL_D_GRAY,
  COLOR1,
  COLOR4,
  BORDER_ACC_INFO,
  COLOR5,
} from '../../constants';
import Border from '../../images/border.svg';

export const BusinessAccountInfoStyles = {
  selectParticipantContainer: {
    paddingRight: '20px',
    '@media (max-width:901px)': {
      paddingRight: '0px',
      paddingBottom: '15px',
    },
  },
  accParticipantStyle: {
    width: '254px',
  },
  addParticipantBtnContainer: {
    '@media (max-width:901px)': {
      textAlign: 'center',
    },
  },
  customSwitchLabel: {
    marginRight: '30px',
    '@media (max-width:601px)': {
      font: '400 16px/18px Arial',
    },
  },
  signerLabel: {
    paddingLeft: '20px',
    paddingRight: '10px',
    '@media (max-width:600px)': {
      paddingLeft: 0,
    },
  },
  addParticipantBtn: {
    margin: '8px',
    borderRadius: '56px',
    maxWidth: '250px',
    color: COLOR5,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '16px',
    height: '40px',
    lineHeight: '20px',
    '&:focus': {
      outline: `2px solid ${COLOR5}`,
      outlineOffset: '2px',
    },
    '@media (max-width:901px)': {
      maxWidth: 'none',
      width: '80%',
    },
  },
  addBorder: {
    border: '1.6px solid #FD0000',
  },
  removeBorder: {
    border: `1.6px solid ${COLOR5}`,
  },
  selectParticipant: {
    marginBottom: '30px',
    display: 'flex',
    '@media (max-width:601px)': {
      marginBottom: '10px',
    },
  },
  customswitch_label: {
    paddingLeft: '20px',
    paddingRight: '10px',
    '@media (max-width:601px)': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
  },
  accSummary: {
    borderBottom: '1px solid #C5CEE0',
    '&.Mui-expanded': {
      minHeight: 'fit-content',
      padding: '12px 25px',
      width: '100%',
    },
  },
  accSummary2: {
    padding: '0px 25px',
    width: '100%',
  },
  accDetails: {
    padding: '25px',
  },
  accSummaryContent: {
    '&.Mui-expanded': {
      margin: '0',
    },
  },
  addParticipantTypography: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '21px',
    color: COLOR1,
  },
  mainAccordion: {
    borderRadius: '10px',
    '&.Mui-expanded': {
      margin: '0',
      border: '1px solid #F3F3F3',
      borderRadius: '10px',
      boxShadow: 'none',
      background: COLOR4,
    },
    '&::before': {
      opacity: '0',
    },
    '@media (max-width:600px)': {
      border: '1px solid #F3F3F3',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
      marginTop: '30px',
    },
  },
  customSwitch_heading: { '@media (max-width:600px)': { margin: '10px' } },
  collapseIcon: { marginTop: '15px' },
  addSigner_Head: {
    fontSize: '20px',
    letterSpacing: '0.11px',
    font: 'normal normal bold 18px/21px Arial',
    opacity: 1,
    marginTop: '11px',
    marginBottom: '15px',
    marginRight: '50px',
    lineHeight: '27px',
    '@media (max-width:1327px)': { marginTop: '30px', fontSize: '16px' },
    '@media (max-width:650px)': { margin: '30px 0 30px 0', fontSize: '16px' },
    '@media (max-width:600px)': {
      font: 'normal normal 700 22px/32px Arial',
      margin: '25px 0 10px 0',
    },
  },
  addSignerSubheading: {
    marginRight: '30px',
    marginBottom: '15px',
    '@media (max-width:600px)': {
      marginBottom: '30px',
      font: 'normal normal 400 16px/18px Arial',
    },
  },
  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },
  ssn_width: { '@media (min-width:960px)': {} },
  owner_padding: {
    margin: '20px 0px 0px 0px',
    paddingLeft: '0px',
    '@media (min-width:960px)': {},
    '@media (min-width:960px) and (max-width:1024px)': {},
  },
  homeAddress: {
    '@media (max-width:960px)': { margin: '0px' },
    '@media (max-width:600px)': { margin: '0' },
  },
  businessid_top_text_upload_id: {
    font: 'normal 700 14px/18px Arial',
    marginBottom: '10px !important',
    '@media (max-width:600px)': { marginBottom: '10px !important' },
  },
  businessAccount_second_grid: {
    margin: '16px 48px 20px 48px',
    '@media (max-width:650px)': { marginRight: '25px', marginLeft: '25px' },
    '@media (max-width:330px)': { marginRight: '20px', marginLeft: '20px' },
    '@media (min-width:1450px)': { width: '1360px' },
  },
  topabove_grid: {
    font: 'normal normal 700 24px/28px Arial',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:1086px)': { fontSize: '20px', lineHeight: '25px' },
    '@media (max-width:960px)': { marginBottom: '10px' },
    '@media (max-width:852px)': { marginBottom: '26px' },
    '@media (max-width:600px)': {
      font: 'normal normal 700 24px/28px Arial',
      margin: '10px 0px 0px 0px',
    },
  },
  checkbox_label_style: {
    marginLeft: '2px',
    textAlign: 'left',
    font: 'normal normal 300 16px/18px Arial',
    letterSpacing: '0.11px',
    color: COLOR1,
    opacity: 1,
  },
  uploadID: {},
  idUploadStyle: {
    marginTop: '20px',
    marginLeft: '407px',
    '@media (max-width:960px)': { marginLeft: '0px' },
    '@media (min-width:960px) and (max-width:1024px)': { marginLeft: '304px' },
    '@media (min-width:1024px) and (max-width:1124px)': { marginLeft: '329px' },
    '@media (min-width:1124px) and (max-width:1336px)': { marginLeft: '378px' },
    '@media (min-width:1137px) and (max-width:1450px)': {
      marginTop: '41px',
      marginLeft: '496px',
    },
  },
  border_grey_line: { margin: '30px 0px', border: '1px solid #D0D0D0' },
  checkbox_content_position: {
    display: 'block',
    position: 'relative',
    top: '-20px',
    left: '32px',
    width: 'fit-content',
    marginRight: '30px',
    '@media (max-width:600px)': { top: '-18px', left: '27px' },
  },
  compliance_stepper: {
    width: '100%',
    margin: '37px 0 43px 50px',
    '@media (max-width:600px)': { margin: '25px 25px 20px 25px' },
    '@media (max-width:650px)': { margin: '25px 25px 20px 25px' },
  },
  top_text_upload_id: {
    font: 'normal normal 100 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR1,
    opacity: 1,
    textAlign: 'left',
    '@media (max-width:650px)': {
      font: 'normal normal normal 18px/21px Arial',
      letterSpacing: '0.12px',
      color: ORIENTAL_D_GRAY,
      textAlign: 'center',
    },
    '@media (max-width:600px)': { marginBottom: '10px' },
  },
  statement_top_txt: { display: 'inline-block', width: '160px' },
  businessAccount_grid_margin: {
    background: COLOR4,
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
    borderRadius: '6px',
    padding: '25px 30px 20px',
    opacity: 1,
    '@media (max-width:1200px)': { padding: '25px 25px 20px' },
    '@media (max-width:600px)': {
      border: 'none',
      boxShadow: 'none',
      padding: '0',
    },
    '@media (max-width:330px)': { marginRight: '20px', marginLeft: '20px' },
    '@media (min-width:1450px)': { maxWidth: '1360px' },
  },
  businessAccount_padding: {
    paddingBottom: '20px',
  },
  personalWrapper: {},
  idDescriptionWrapper: {
    margin: '0px',
    marginBottom: '16px',
    '@media (max-width:960px)': {
      width: '100%',
      margin: '0',
    },
    '@media (max-width:650px)': {
      marginTop: '25px',
      width: '100%',
    },
    '@media (max-width:600px)': {
      marginTop: '0px',
      width: '100%',
    },
  },
  dotted_border: {
    backgroundImage: `url(${Border})`,
    width: '95%',
    height: '2px',
    color: `${BORDER_ACC_INFO} !important`,
    '@media (max-width:650px)': {
      height: '1px',
    },
  },
  idDescriptionOne: {
    display: 'flex',
    alignItems: 'baseline !important',
    color: '#444444',
    font: 'normal normal bold 18px/21px Arial',
    padding: '0px 20px 0px 0px',
    '@media (max-width:960px)': {
      font: 'normal normal bold 16px/17px Arial',
      padding: '0px',
    },
    '@media (min-width:960px)': {
      justifyContent: 'flex-start',
    },
  },
  base_align: {
    '@media (min-width:960px)': {
      alignItems: 'end',
    },
  },
  label_title: {
    marginBottom: '0px !important',
  },
  ssn_grid: {
    position: 'relative',
  },
  ssn_padding: {
    // paddingRight: '40px',
    '@media (max-width:960px)': {
      paddingRight: '0px',
    },
  },
  ownership_grid: {
    '@media (min-width:960px)': {
      width: '175px',
    },
  },
  ownership_label: {
    background: COLOR4,
    borderRadius: '6px',
    marginBottom: '2px !important',
    '@media (max-width:600px)': {
      marginBottom: '10px !important',
    },
  },
  idDescriptionToggle: {
    font: 'normal normal normal 16px/17px Arial',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:960px)': {
      marginTop: '7px',
      font: 'normal normal normal 14px/16px Arial',
    },
    '@media (max-width:600px)': {
      font: 'normal normal normal 14px/16px Arial',
      display: 'inherit',
    },
  },
  headingAdddress: {
    font: 'normal normal normal 22px/24px Arial',
    display: 'flex',
    alignItems: 'center',
    marginTop: '15px',
    '@media (max-width:960px)': {
      marginTop: '7px',
      font: 'normal normal normal 20px/22px Arial',
    },
  },
  idDescriptionTwo: {
    width: '546px',
    height: '19px',
    font: 'normal normal 700 16px/18px Arial',
    color: ORIENTAL_ORANGE,
    marginTop: '34px',
    '@media (max-width:960px)': {
      marginTop: '30px',
      width: 'auto',
      font: 'normal normal 700 14px/16px Arial',
    },
    '@media (max-width:600px)': {
      height: 'auto',
    },
  },
  idDescriptionTwocopy: {
    font: 'normal normal 700 16px/18px Arial',
    color: ORIENTAL_ORANGE,
    marginTop: '25px',
    '@media (max-width:960px)': {
      marginTop: '12px',
      font: 'normal normal 600 14px/16px Arial',
    },
  },
  plus: {
    width: '3px',
    height: '3px',
    color: 'white',
  },
  inputs_grid_margin_HA: {
    paddingTop: '15px',
  },
  error_idupload: {
    color: COLOR2,
    margin: '2px',
    display: 'block',
    textAlign: 'center',
    fontSize: '16px',
  },
  button_grid: {
    padding: '22px',
    justifyContent: 'flex-end',
    textAlign: 'right',
    '@media (max-width:650px)': {
      paddingTop: '35px',
      paddingBottom: '20px',
      justifyContent: 'center',
      paddingLeft: 0,
    },
  },
  compliance_button_container: {
    '@media (max-width:650px)': {
      justifyContent: 'center',
      display: 'flex',
      maxWidth: '80%',
    },
  },
  businessAccount_container: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    opacity: 1,
    borderRadius: '30px',
  },
  sidebarGrid: {},
  form_heading_info: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal 700 24px/28px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:650px)': {
      font: 'normal normal 700 22px/32px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      margin: '0',
      marginBottom: '5px',
    },
  },
  BusinessOwnerToggle_content: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '25px',
    width: '272px',
    height: '21px',
    font: 'normal normal 700 14px/16px Arial',
    fontWeight: '700',
    '@media (max-width:600px)': {
      display: 'block',
      width: 'unset',
      height: 'unset',
    },
  },
  BusinessToggle_content: {
    display: 'flex',
    width: '250px',
    height: '21px',
    alignItems: 'center',
    font: 'normal normal normal 14px/16px Arial',
    fontWeight: '700',
    marginLeft: '356px',
    marginTop: '-22px',
    marginBottom: '10px',
    '@media (max-width:960px)': {
      marginLeft: '1px',
      marginTop: '15px',
    },
  },
  more_about_sub_head: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal 700 24px/28px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:650px)': {
      font: 'normal normal 700 22px/32px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      marginBottom: '5px',
      marginTop: '0',
    },
  },
  inputs_container: {
    marginTop: '30px',
    '@media (max-width:650px)': {
      marginTop: '0',
    },
  },
  snackbarRoot: {
    width: '100%',
    // height: '43px',
    position: 'relative',
    disaplay: 'flex',
    // justifyContent: 'flex-end',
    zIndex: '10',
    top: '-10px',
    left: '0 !important',
    // right: '0 !important',
    '@media (max-width:1310px)': {
      height: 'auto',
    },
    '@media (max-width:600px)': {
      left: '0 !important',
      right: '0 !important',
    },
  },
  snackBarBtn: {
    padding: '0px',
    height: '20px',
    marginTop: '10px',
    color: COLOR1,
  },
  snackbarStyleViaContentProps: {
    color: COLOR1,
    backgroundColor: ORIENTAL_ORANGE,
    // width: '100%',
    font: 'normal 700 14px/22px Arial',
    padding: '7.6px 20px',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    minWidth: 'unset',
  },
  message: {
    // width: '100%',
    display: 'flex',
  },
};
